import { Flex, FlexProps, Text } from '@chakra-ui/react'
import { ReactNode } from 'react'

export interface ContainerSelectProps extends FlexProps {
    children: ReactNode
    label: string
}

export default function ContainerSelect({
    label,
    children,
    ...nextProps
}: ContainerSelectProps) {
    return (
        <Flex
            {...nextProps}
            alignItems="center"
            bg={'base-4'}
            pl="4"
            borderRadius="full"
        >
            <Text
                display={{ base: 'none', md: 'flex' }}
                fontSize="xs"
                whiteSpace="nowrap"
            >
                {label}
            </Text>
            {children}
        </Flex>
    )
}
